import { axiosInstance } from "@/pages/auth/auth.context";

export type InvoiceSlot = "FIRST" | "SECOND";

/** Stripe's own invoice status, or "missing" when Stripe has no such invoice. */
export type StripeInvoiceStatus =
  "draft" | "open" | "paid" | "void" | "uncollectible" | "missing";

export interface InvoiceSync {
  slot: InvoiceSlot;
  invoiceId: string;
  /** The voided invoice this sync swapped out for its revision, if any. */
  replacedInvoiceId: string | null;
  status: StripeInvoiceStatus;
  paidAt: string | null;
}

export interface StripeSyncResult {
  invoices: InvoiceSync[];
  signupsOpened: boolean;
}

export interface StripeInvoiceIds {
  stripeInvoiceId: string | null;
  stripeSecondInvoiceId: string | null;
}

export const stripeInvoiceService = {
  async sync(eventId: string): Promise<StripeSyncResult> {
    const response = await axiosInstance.post<StripeSyncResult>(
      `event/${eventId}/stripe/sync`,
    );
    return response.data;
  },

  /** Checks each id with Stripe before saving, then syncs. */
  async updateIds(
    eventId: string,
    ids: StripeInvoiceIds,
  ): Promise<StripeSyncResult> {
    const response = await axiosInstance.put<StripeSyncResult>(
      `event/${eventId}/stripe/invoices`,
      ids,
    );
    return response.data;
  },
};
